const searchBtn = document.querySelector('.c-search-toggle--d');
const searchBtnMobile = document.querySelector('.c-search-toggle--m');
const searchCloseBtn = document.querySelector('.c-search-close-btn');
const navbarToggleBtn = document.querySelector('.navbar-toggler');
const headerMask = document.querySelector('.c-header-mask');
//滾動時會變色的所有元素
const elements = ['.navbar-toggler', '.logo-gap-line', '.logo-text', '.l-header', '.c-lang-switch__btn', '.c-search-toggle--d'];

searchBtn.addEventListener('click', showMask);

searchBtnMobile.addEventListener('click', showMask);

searchCloseBtn.addEventListener('click', (e) => {
  e.preventDefault()
  document.querySelector('.l-header').style.display = 'flex';
  document.querySelector('.l-search').style.display = 'none';
  document.querySelector('.c-search-input').value = '';
  headerMask.style.display = 'none';
});

headerMask.addEventListener('click', (e) => {
  if (window.innerWidth <= 1200) {
    if (document.querySelector('.l-search').style.display === 'none') {
      headerMask.style.display = 'none';
      navbarToggleBtn.click();
    } else {
      document.querySelector('.l-header').style.display = 'flex';
      document.querySelector('.l-search').style.display = 'none';
      headerMask.style.display = 'none';
      navbarToggleBtn.click();
    }
  } else {
    document.querySelector('.l-header').style.display = 'flex';
    document.querySelector('.l-search').style.display = 'none';
    headerMask.style.display = 'none';
  }
});

navbarToggleBtn.addEventListener('click', (e) => {
  if (e.currentTarget.getAttribute('aria-expanded') === 'true') {
    headerMask.style.height = `${document.body.scrollHeight}px`;
    headerMask.style.display = 'block';
    elements.forEach( el => {
      document.querySelector(`${el}`).classList.add('scrolling');
    });

    document.querySelectorAll('.navbar-nav .nav-link').forEach(el => {
      el.classList.add('scrolling');
    });

    document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo.png');
  } else {
    headerMask.style.display = 'none';
    if (window.scrollY >= 212) {
      elements.forEach( el => {
        document.querySelector(`${el}`).classList.add('scrolling');
      });

      document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo.png');
    } else {
      setTimeout(() => {
        elements.forEach( el => {
          document.querySelector(`${el}`).classList.remove('scrolling');
        });

        document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo-default.png');
      }, 300);
    }
  }
});

window.addEventListener('scroll', changeColor);

window.addEventListener('load', changeColor);

window.addEventListener('resize', changeColor)

function changeColor () {
  if (document.querySelector('.navbar-collapse.show') !== null) return;
  // 螢幕寬度在576以下滾動96px就必須變色
  if (window.innerWidth <= 576) {
    if (window.scrollY >= 96) {
      elements.forEach( el => {
        document.querySelector(`${el}`).classList.add('scrolling');
      });

      document.querySelectorAll('.navbar-nav .nav-link').forEach(el => {
        el.classList.add('scrolling');
      });

      document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo.png');
    } else {
      elements.forEach( el => {
        document.querySelector(`${el}`).classList.remove('scrolling');
      });

      document.querySelectorAll('.navbar-nav .nav-link').forEach(el => {
        el.classList.remove('scrolling');
      });

      document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo-default.png');
    }
  } else {
    if (window.scrollY >= 100) {
      elements.forEach( el => {
        document.querySelector(`${el}`).classList.add('scrolling');
      });

      document.querySelectorAll('.navbar-nav .nav-link').forEach(el => {
        el.classList.add('scrolling');
      });

      document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo.png');
    } else {
      elements.forEach( el => {
        document.querySelector(`${el}`).classList.remove('scrolling');
      });

      document.querySelectorAll('.navbar-nav .nav-link').forEach(el => {
        el.classList.remove('scrolling');
      });

      document.querySelector('.img-logo').setAttribute('src', 'assets/images/logo-default.png');
    }
  }
}

function showMask() {
  document.querySelector('.l-header').style.display= 'none';
  document.querySelector('.l-search').style.display = 'flex';
  headerMask.style.height = `${document.body.scrollHeight}px`;
  headerMask.style.display = 'block';
}
